// ============================================================
// Theme — Farbtoken (statisch + dynamisch via Custom Event)
// ============================================================

export const CO = {
  bg: '#eef0ec',
  card: '#ffffff',
  border: '#e2e5de',
  border2: '#eceee9',
  text: '#1a1e1b',
  muted: '#6c7269',
  faint: '#9aa094',
  einsatz: '#5f7183',
  auszahlung: '#55b941',
  neg: '#c23b34',
  pos: '#2f8f52',
  sidebar: '#c7db00',
  sidebar2: '#b8cb00',
} as const;

export const ARTC: Record<string, string> = {
  'LOTTO - Normal': '#c79a2b',
  'Eurojackpot - Normal': '#3f6f8f',
  'GlücksSpirale': '#7d6a9c',
  'Doppelte Sieben': '#b06a4f',
  'MillionenKracher': '#5a8a6a',
};

export function artColor(a: string): string {
  return ARTC[a] || '#8a9184';
}

// Bestimmt lesbare Vorder-/Border-Farben für Inhalte, die auf der
// dynamisch konfigurierbaren Brand-Farbe platziert sind.
export function readableOnBrand(hex: string): {
  fg: string;
  fg80: string;
  fg60: string;
  line: string;
  chip: string;
} {
  const clean = hex.replace('#', '');
  const full = clean.length === 3 ? clean.split('').map((c) => c + c).join('') : clean;
  const r = parseInt(full.slice(0, 2), 16) / 255;
  const g = parseInt(full.slice(2, 4), 16) / 255;
  const b = parseInt(full.slice(4, 6), 16) / 255;
  const lin = (c: number) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  const L = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  if (L > 0.45) {
    return {
      fg: '#171c12',
      fg80: 'rgba(20,26,14,.82)',
      fg60: 'rgba(20,26,14,.6)',
      line: 'rgba(20,26,14,.14)',
      chip: 'rgba(20,26,14,.08)',
    };
  }
  return {
    fg: '#ffffff',
    fg80: 'rgba(255,255,255,.82)',
    fg60: 'rgba(255,255,255,.6)',
    line: 'rgba(255,255,255,.14)',
    chip: 'rgba(255,255,255,.14)',
  };
}
